<app-nav *ngIf="!hideNav"></app-nav>
<main id="main">
  <router-outlet></router-outlet>
</main>
<lib-preloader [loading]="loading"></lib-preloader>
